import { MasterKey } from '@overtur-monorepo/keying-hierarchy'
import { Keyway } from '@overtur-monorepo/keying-shared'
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { fadeIn } from '../../../animations/fadeIn'
import { Cylinder, KeySystem, Structure } from '../../../models/dev.test.models'
import { KeyingBookService } from '../../../services/keying.book.service'
import { KeyingDataSetsService } from '../../../services/keying.data.sets.service'
import { KeyNodeType } from '@overtur-monorepo/keying-shared'
import { FormControl, FormGroup } from '@angular/forms'
import { DialogService } from '../../../services/dialog.service'
import { MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { AppRoutingConfig } from '../../../configuration/app.routing.config'
import { AddCompetitorPinningDialog } from '../../../dialogs/add-competitor-pinning-dialog/add-competitor-pinning-dialog.component'

@Component({
  selector: 'app-special-function-keys',
  templateUrl: './special-function-keys.component.html',
  styleUrls: ['./special-function-keys.component.scss'],
  animations: [fadeIn],
  standalone: false,
})
export class SpecialFunctionKeysComponent implements OnInit, OnChanges, OnDestroy {
  destroy$ = new Subject()
  @Input() structure: Structure = null
  @Input() keySystem: KeySystem = null
  @Input() selectedCylinder: Cylinder
  @Input() selectedMasterKey: MasterKey = null

  @Output() addKey = new EventEmitter()
  @Output() removeKey = new EventEmitter()

  cylinderKeyways: Keyway[] = []
  keyNodeType = KeyNodeType
  specialFunctionKeyNames = []
  filteredSpecialFunctionKeyNames: any[] = []
  listOfKeyNames
  listKeyCylinders
  isKeyNameSelected: boolean

  form = new FormGroup({
    keyName: new FormControl(''),
  })

  dialogRef: MatDialogRef<unknown, any>
  noOfCylindersUpdated = 0
  message = ''

  @ViewChild('successDialogContent') successDialogContent: TemplateRef<any>

  constructor(
    public keyingDataSetsService: KeyingDataSetsService,
    public keyingBookService: KeyingBookService,
    private router: Router,
    public dialogService: DialogService
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.isKeyNameSelected = false
  }

  /* istanbul ignore next */
  ngOnChanges(changes: SimpleChanges): void {
    this.listKeyCylinders = []
    this.specialFunctionKeyNames = []
    this.filteredSpecialFunctionKeyNames = []
    if (changes.keySystem?.currentValue) {
      // console.log(changes.keySystem.currentValue)
      this.listKeyCylinders = changes.keySystem.currentValue.masterKeysKeying.squashIncludeChangeKeys()
      this.listKeyCylinders.forEach((element) => {
        if (
          element.isAssigned === true &&
          (element.masterKeyTypeId === this.keyNodeType.ControlKey ||
            element.masterKeyTypeId === this.keyNodeType.ConstructionKey ||
            element.masterKeyTypeId === this.keyNodeType.Master ||
            element.masterKeyTypeId === this.keyNodeType.SelectiveMaster)
        ) {
          this.specialFunctionKeyNames.push(element.keySetSymbol)
        }
      })
      //Remove duplicates
      this.filteredSpecialFunctionKeyNames = Array.from(new Set(this.specialFunctionKeyNames))
    }

    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      const keyName: string = value.keyName

      this.filteredSpecialFunctionKeyNames = Array.from(
        new Set(
          this.specialFunctionKeyNames.filter((name: string) => {
            return name.toLowerCase().includes(keyName.toLowerCase())
          })
        )
      )
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  onRemoveKey() {
    const onCompleted = (result: any = {}) => {
      this.form.reset({ keyName: '' })
      this.noOfCylindersUpdated = result.noOfCylindersUpdated
      if (result.noOfCylindersUpdated === 0 && result.isUpdateMovedToOfflineProcess) {
        this.message = result.message
        this.router.navigate([AppRoutingConfig.structuresUrl])
      } else {
        this.message = `${result.noOfCylindersUpdated} of ${result.totalCylinders} cylinder(s) updated.`
      }
      this.dialogRef = this.dialogService.open(this.successDialogContent)
      return this.dialogRef.afterClosed()
    }
    const { keyName } = this.form.value
    this.removeKey.emit({ keyName, onCompleted: onCompleted.bind(this) })
  }

  onAddKey() {
    const { keyName } = this.form.value
    const convertToStr = JSON.stringify(keyName)
    if (
      convertToStr.includes('CONL') &&
      (this.structure.keywayFamilyId === 9 || this.structure.keywayFamilyId === 10)
    ) {
      const dialogRef = this.dialogService.open(AddCompetitorPinningDialog)
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.updateSfkWithPinning(keyName, data)
        }
      })
    } else {
      this.updateSfkWithPinning(keyName)
    }
  }

  updateSfkWithPinning(keyName, competitorInfo = '') {
    const onCompleted = (result: any = {}) => {
      this.form.reset({ keyName: '' })
      this.noOfCylindersUpdated = result.noOfCylindersUpdated
      if (result.noOfCylindersUpdated === 0 && result.isUpdateMovedToOfflineProcess) {
        this.message = result.message
        this.router.navigate([AppRoutingConfig.structuresUrl])
      } else {
        this.message = `${result.noOfCylindersUpdated} of ${result.totalCylinders} cylinder(s) updated.`
      }
      this.dialogRef = this.dialogService.open(this.successDialogContent)
      return this.dialogRef.afterClosed()
    }
    this.addKey.emit({ keyName, competitorInfo, onCompleted: onCompleted.bind(this) })
  }

  setKeyName(keyName) {
    if (keyName) {
      this.isKeyNameSelected = true
    }
  }

  keyPress(event) {
    if (event) {
      this.isKeyNameSelected = false
    }
  }
}
